export enum AbilityState {
  /**
   * Indicates that the feature is fully enabled and accessible
   * for the current account.
   *
   * The feature’s UI elements should be visible and fully interactive,
   * allowing the user to utilize the feature without restrictions.
   */
  ENABLED = 'enabled',

  /**
   * Indicates that the feature is available to the current account,
   * but not yet enabled.
   *
   * This state implies that the feature could be accessed by fulfilling
   * certain conditions (e.g., purchasing a product, upgrading the account’s
   * role within a team, acquiring billing permissions, etc.).
   *
   * In this state, the feature’s UI should be displayed to inform the user
   * of its availability, but all interactive functionality must be disabled
   * until the necessary conditions are met.
   */
  LIMITED = 'limited',

  /**
   * Indicates that the feature is blocked and entirely inaccessible
   * to the current account.
   *
   * In this state, any UI elements associated with the feature must be
   * hidden, and all attempts to use the feature should be strictly prevented.
   *
   * Example: The feature is tied to a product, but that product itself is
   * unavailable to the user.
   */
  BLOCKED = 'blocked',
}
